import { createSafeContext } from '@/util';

import type { VDatePickerContextValue } from './type';

const VDatePickerContext = createSafeContext<VDatePickerContextValue>();

export default VDatePickerContext;
